/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import NeedleAnalytic from "@package/services/src/Needle"
import { EmptyResult } from "@package/services/src/Result"

import { NeedleAnalyticsService } from "./services"

export default class NeedleAnalyticsApiService implements NeedleAnalyticsService {
  constructor(private needle: NeedleAnalytic) { }

  public async removeNeedleScript(): Promise<any> {
    try {
      if (this.needle) {
        await this.needle.removeNeedle()
      }
      return new EmptyResult()
    } catch (error) {
      console.warn('Needle was not provided')
    }
  }

  public async reloadNeedleScript(): Promise<any> {
    try {
      if (this.needle) {
        await this.needle.reloadNeedle()
      }
      return new EmptyResult()
    } catch (error) {
      console.warn('Needle was not provided')
    }
  }
}
